// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CellColorSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import SettingByRange from './Izenda.SettingsByRange';
import GridLayout from './Izenda.GridLayout';
import DropDown from './Izenda.DropDown';
import localizer from 'share/localization/Izenda.Localizer';
import { get } from 'lodash/fp';
import Constants from 'logic/data/Izenda.SettingsByRangeConstants';

const DATA_TYPE = Constants.DATA_TYPE;

@observer
export default class CellColorSettings extends Component {
  static propTypes = {
    value: React.PropTypes.object
  };

  static getDefaultProps = {
    settingValue: {},
    pointOptionsList: [{}]
  };

  constructor(props) {
    super(props);
    this.settingByRangeRef = null;
    const pointOptionList = props.pointOptionList || [{}];
    this.state = { selectedPoint: pointOptionList[0].pointType };
    this.initData();
  }

  getValue = () => {
    this.settings[this.state.selectedPoint] = this.getSettingValue();
    return this.settings;
  };

  getSettingValue = () => {
    if (this.settingByRangeRef) {
      return this.settingByRangeRef.getValue();
    }
    return {};
  };

  /**
   * Add default data for Value settings
   */
  initData = () => {
    const props = this.props;
    const settings = toJS(props.settingValue) || {};
    const pointKeys = props.pointOptionList.map(point => point.pointType);
    pointKeys.forEach(key => !settings[key] && (settings[key] = {}));
    this.settings = settings;
  };

  beforeClosing = (valManager: any, btnType: string) => {
    return this.settingByRangeRef.beforeClosing(valManager, btnType);
  };

  setSettingByRangeRef = (element: any) => {
    this.settingByRangeRef = element;
  };

  render() {
    const selectedPoint = this.state.selectedPoint;
    const selectedSettingValue = this.settings[selectedPoint];
    const { isBubbleContainer, validateMessages, defaultValue, pointOptionList } = this.props;

    const settingByRangeProps = {
      settingValue: selectedSettingValue,
      defaultValueType: selectedSettingValue.rangeValue ? 'rangeValue' : selectedSettingValue.value ? 'value' : 'none',
      dataType: DATA_TYPE.NUMERIC, 
      haveName: true,
      isHiddenValueOption: isBubbleContainer,
      validateMessages: validateMessages,
      valueProps: {
        title: localizer.getText('COLOR_SETTING_TOOLTIP'),
        type: 'color',
        defaultColor: defaultValue
      }
    };

    return (
      <div className="izenda-CellColorSettings">
        <GridLayout className="u_paddingAll">
          <GridLayout.Row>
            <GridLayout.Col cols={5} className="u_controlHeight">
              <span>{localizer.getText('COLOR_SETTING_POINT_OPTIONS')}</span>
            </GridLayout.Col>
            <GridLayout.Col cols={7}>
              <DropDown
                options={pointOptionList}
                onChange={this.handleChangePlotOption}
                value={selectedPoint}
                valueField="pointType"
                labelField={getLabelField}
              />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
        <SettingByRange {...this.props} {...settingByRangeProps} ref={this.setSettingByRangeRef} />
      </div>
    );
    // settingByRange

    function getLabelField(option) {
      const pointTypeName = get('pointTypeName', option);
      return localizer.getText(['REPORT_PART_MAP_POINT', pointTypeName].join('_'));
    }
  }

  handleChangePlotOption = (newVal: any, newValDetails: any) => {
    const props = this.props;
    const popupContent = this.settingByRangeRef || {};
    const popupContentProps = props.popupContentProps || {};
    const valManager = props.validation;

    const beforeCloseFn = popupContentProps.beforeClosing;
    if (beforeCloseFn && popupContent[beforeCloseFn]) {
      return popupContent[beforeCloseFn](valManager, 'accept').then(canChange => {
        if (canChange) {
          return valManager.validate().then(success => {
            if (success) {
              this.settings[this.state.selectedPoint] = this.getSettingValue();
              this.setState({
                selectedPoint: newValDetails.pointType
              });
            } else {
              return Promise.reject(false);
            }
          });
        } else {
          return Promise.reject(false);
        }
      });
    }
    return Promise.resolve(true);
  };
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.CellColorSettings.js